import { useState } from 'react';

import { onlyDigits } from '../../../utils/format';
import { validateCode } from '../../../helpers/api/claims-site-api';

import type { IValidateCodeState } from './models';
import { IDLE, PENDING, REJECTED, RESOLVED } from './config';

export const CODE_REQUIRED_LENGTH = 6;

const initialState: IValidateCodeState = {
    status: IDLE,
};

export const useValidateCode = () => {
    const [state, setState] = useState<IValidateCodeState>(initialState);

    const request = async (code: string, phone: string, messageId: string) => {
        setState({ ...initialState, status: PENDING });
        const data = { phoneNumber: onlyDigits(phone), code, messageId };

        await validateCode(data)
            .then(({ errorMessage }) => {
                if (errorMessage) {
                    throw new Error(errorMessage);
                }
                setState(prevState => ({ ...prevState, status: RESOLVED }));
            })
            .catch(error => {
                setState(prevState => ({
                    ...prevState,
                    status: REJECTED,
                    error: error.message,
                }));
            });
    };

    const resetState = () => setState(initialState);

    return { state, resetState, request };
};
